import React from "react";
import ClassNames from "classnames";
import SeemPopover from "../SeemPopover/SeemPopover";
import { openManagementModesEnum } from "../SeemPopover/Popover";
import Tooltip from "../Tooltip/Tooltip";
import "./LabeledValue.scss";

export interface LabeledValueProps {
  label?: string;
  linkText: string;
  href?: string;
  img?: string;
  alt?: string;
  icon?: string;
  popoverContent?: React.ReactNode;
  tooltipContent?: string;
  className?: string;
}

const LabeledValue: React.FC<LabeledValueProps> = ({
  label,
  linkText,
  href,
  img,
  alt = "",
  icon,
  popoverContent,
  tooltipContent,
  className = "",
}) => {
  const statusGroup = (
    <span className="labeled-value-status">
      {!!img && <img className="labeled-value-img" src={img} alt={alt} />}
      {!img && !!icon && (
        <i className={`seem-icon ${icon} labeled-value-icon`} />
      )}
      {!!href ? (
        <a
          className="labeled-value-anchor"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {linkText}
        </a>
      ) : (
        <span className="labeled-value-text">{linkText}</span>
      )}
    </span>
  );

  const statusGroupWithTooltip = (
    <Tooltip type="info" placement="top" content={tooltipContent}>
      {statusGroup}
    </Tooltip>
  );

  return (
    <div className={ClassNames("labeled-value", className)}>
      {!!label && <span className="labeled-value-label">{label}</span>}
      {!!popoverContent ? (
        <SeemPopover
          openManagementMode={openManagementModesEnum.HOVER}
          triggerClassName="labeled-value-trigger"
          placement="right"
          body={popoverContent}
        >
          {statusGroupWithTooltip}
        </SeemPopover>
      ) : (
        statusGroupWithTooltip
      )}
    </div>
  );
};

export default LabeledValue;
